import { BiCoinStack, BiRocket } from 'react-icons/bi';
import { CgToolbox } from 'react-icons/cg';
import { RiToolsFill } from 'react-icons/ri';
import { IoMdWallet } from 'react-icons/io';
import { MdDashboard, MdFilterFrames } from 'react-icons/md';
import AnimatedAtom from 'components/AnimatedAtom/AnimatedAtom';
import { AiOutlineBank, AiOutlineFundProjectionScreen } from 'react-icons/ai';
import { GiArchBridge, GiAtomicSlashes, GiPayMoney, GiReceiveMoney } from 'react-icons/gi';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import { ImStack } from 'react-icons/im';

const menuItems = [
    { name: 'Dashboard', pathname: '/', Icon: MdDashboard },
    { name: 'Stacker NFT', pathname: '/stacker', Icon: ImStack },
    {
        name: 'Buy & Stake',
        Icon: AiOutlineBank,
        subItems: [
            { name: 'Stake Liquid', pathname: '/stake', Icon: BiCoinStack },
            { name: 'Accelerator', pathname: '/accelerator', Icon: AnimatedAtom },
            { name: 'Collider', pathname: '/collider', Icon: GiAtomicSlashes },
            { name: 'NFTs', Icon: MdFilterFrames, pathname: '/nft' },
        ],
    },
    {
        name: 'Launch',
        Icon: BiRocket,
        subItems: [
            { name: 'Launches', pathname: '/launch', Icon: AiOutlineFundProjectionScreen },
            { name: 'Pledge', pathname: '/pledge', Icon: GiPayMoney },
            { name: 'Vesting', pathname: '/vesting', Icon: GiReceiveMoney },
        ],
    },
    {
        name: 'Utilities',
        Icon: CgToolbox,
        subItems: [
            // { name: 'Bridge', pathname: '/bridge', Icon: GiArchBridge },
            { name: 'Voting', pathname: '/voting', Icon: HowToVoteIcon },
            { name: 'Tools', pathname: '/tools', Icon: RiToolsFill },
            { name: 'Add AXN Token', Icon: IoMdWallet, isMetamask: true },
        ],
    },
];

export default menuItems;
